export default "__VITE_ASSET__DFbNlGms__"